import styled from 'styled-components';
import { FOOTER_FULL } from '../../constants';
import {
  boxShadow,
  breakpoints,
  colors,
  sideMenuWidth,
  headerHeightDesktop,
  text,
  verticalGutter
} from '../../styles';

export default styled.footer`
  box-shadow: ${boxShadow.footer};
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding-bottom: 1rem;
  color: ${colors.grey};

  small {
    font-weight: 300;
  }

  @media screen and (min-width: ${breakpoints.tablet}) {
    height: ${headerHeightDesktop}rem;
    background: #fff;

    &&& {
      position: absolute;
      bottom: 0;
      width: 100%;
      padding-bottom: 0;
    }
  }

  @media screen and (min-width: ${breakpoints.largeMonitor}) {
    &&& {
      width: ${({ footerType }) =>
        footerType === FOOTER_FULL
          ? '100%'
          : `calc(100% - ${sideMenuWidth}px)`};
      left: ${({ footerType }) =>
        footerType === FOOTER_FULL ? '0' : `${sideMenuWidth}px`};
    }
  }

  @media print {
    display: none !important;
  }

  /* namespaced styles */
  .bottomfooter {
    &__links {
      margin: ${verticalGutter}rem / 2 0;
      > li a {
        color: ${colors.grey};
      }
    }

    &__links {
      padding: 0;
      list-style: none;

      > li {
        margin: 1.5rem 0;
        a {
          text-decoration: none;
          &:hover,
          &:focus {
            text-decoration: underline;
          }
        }
      }

      @media only screen and (min-width: ${breakpoints.tablet}) {
        display: inline-block;
        vertical-align: middle;
        margin: 1rem;
        margin-left: -0.5rem;
        font-size: ${text.small};
        > li {
          display: inline-block;
          margin: 0 0.25rem;

          &:after {
            content: '|';
            margin-left: 0.5rem;
            opacity: 0.5;
          }
          &:last-child:after {
            display: none;
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/BottomFooter/BottomFooter.style.js